// Founding page runtime helpers.
//
// This file no longer touches copy. The mechanism lead, the tester count and
// the value stack notes were all being rewritten here at runtime; they now live
// in templates/page.founding.json where they belong, rendered by the sections.
// What is left is behaviour only.
(function () {
  // Chrome restores scroll position on refresh, which can drop someone into the
  // middle of the page. Ads land people at the top; make refreshes behave the same.
  if ('scrollRestoration' in history) history.scrollRestoration = 'manual';

  // The supplement disclaimer now lives in the footer, under the logo, with the
  // copyright and policies. Hide the in-page duplicate. Deliberately a hide and
  // not a removal: if this script fails the disclaimer still shows, which is the
  // safe direction to fail in for a compliance line.
  var main = document.getElementById('MainContent');
  if (main) {
    [].slice.call(main.querySelectorAll('p, div, span')).forEach(function (el) {
      if (el.children.length === 0 && /^A food supplement\./.test(el.textContent.trim())) {
        el.style.display = 'none';
      }
    });
  }

  var strip = document.querySelector('.bs-tmz');
  if (!strip || !strip.children.length) return;

  // Testimonial strip auto-advance.
  //
  // The previous version set paused = true on the first pointerdown, touchstart,
  // wheel or keydown and never cleared it, so a single swipe killed the motion
  // for the rest of the session. Worse on a phone: a vertical page scroll whose
  // finger happens to land on the strip fires touchstart, so the carousel could
  // die without anyone touching it on purpose. Interaction now defers the next
  // advance rather than ending it.
  //
  // There is no "swipe for more" label. Each card is 78% of the width, so the
  // next one is always visibly cut off at the edge, which is the affordance.
  var RESUME_MS = 7000;
  var visible = false;
  var resumeAt = 0;

  ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach(function (ev) {
    strip.addEventListener(ev, function () {
      resumeAt = Date.now() + RESUME_MS;
    }, { passive: true });
  });

  var reduced = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function step() {
    if (!visible || reduced) return;
    if (Date.now() < resumeAt) return;
    var card = strip.children[0];
    if (!card) return;

    var w = card.getBoundingClientRect().width + 12;
    var from = strip.scrollLeft;
    var atEnd = from + strip.clientWidth >= strip.scrollWidth - 8;
    var to = atEnd ? 0 : from + w;

    strip.scrollTo({ left: to, behavior: 'smooth' });

    // Fallback. scroll-snap-type: x mandatory can swallow a smooth programmatic
    // scroll on some engines, and when it does the carousel silently sits still
    // rather than erroring. If nothing has moved shortly after, jump instead.
    // Losing the easing is a much smaller cost than losing the motion.
    setTimeout(function () {
      if (Math.abs(strip.scrollLeft - from) < 2) strip.scrollLeft = to;
    }, 700);
  }

  setInterval(step, 4000);

  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { visible = e.isIntersecting; });
    }, { threshold: 0.25 }).observe(strip);
  } else {
    visible = true;
  }
})();
